import React from 'react';
import { Link } from 'react-router-dom';
import { EMAIL, HP2, PHONE_DISPLAY, PHONE_HREF, SERVICE_ROUTES } from './homepage2/assets';
import '../styles/homepage2.css';
import '../styles/homepage2-app.css';

const SERVICE_LINKS = [
  ['Standard Home Clean', SERVICE_ROUTES.standard_home],
  ['Signature Deep Reset™', SERVICE_ROUTES.deep_reset],
  ['Airbnb Turnover', SERVICE_ROUTES.airbnb],
  ['Commercial Cleaning', SERVICE_ROUTES.commercial],
  ['Move-In / Move-Out Cleaning', SERVICE_ROUTES.move_in_move_out],
];
const COMPANY_LINKS = [
  ['About Us', '/about'],
  ['Contact Us', '/contact'],
  ['Become A Guru', '/careers'],
  ['The Guru Standard', '/#guru-standard'],
  ['How Booking Works', '/#how-booking-works'],
];
const LEGAL_LINKS = [['Policies', '/policies'], ['Privacy', '/privacy'], ['Terms', '/terms'], ['SMS Terms', '/sms-terms']];
const tid = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');

// Approved Homepage 2.0 footer — shared across all public pages.
const Footer = () => (
  <div className="hp2 hp2-footer-root" data-testid="site-footer">
    <footer className="site-footer" id="footer">
      <div className="footer-inner">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" aria-label="Gleam Guru homepage" data-testid="footer-logo"><img src={HP2.logo} alt="Gleam Guru Cleaners" /></Link>
            <p className="footer-tagline">THE MASTERS OF CLEAN.</p>
            <p className="footer-area">Portland, OR &amp; Vancouver, WA</p>
          </div>
          <nav aria-label="Footer services">
            <h2>Services</h2>
            <div className="footer-links">
              {SERVICE_LINKS.map(([name, path]) => (
                <Link key={path} to={path} data-testid={`footer-svc-${tid(name)}`}>{name}</Link>
              ))}
            </div>
          </nav>
          <nav aria-label="Footer company">
            <h2>Company</h2>
            <div className="footer-links">
              {COMPANY_LINKS.map(([name, path]) => (
                <Link key={name} to={path} data-testid={`footer-link-${tid(name)}`}>{name}</Link>
              ))}
            </div>
          </nav>
          <div className="footer-contact">
            <h2>Get in touch</h2>
            <div className="footer-links">
              <a href={PHONE_HREF} data-testid="footer-phone">{PHONE_DISPLAY}</a>
              <a href={`mailto:${EMAIL}`} data-testid="footer-email">{EMAIL}</a>
              <Link className="footer-quote" to="/#quote-form" data-testid="footer-quote-cta">TALK WITH A GLEAM GURU ↗</Link>
            </div>
          </div>
        </div>
        <div className="footer-base">
          <p>© {new Date().getFullYear()} Gleam Guru Cleaners. All rights reserved.</p>
          <nav className="footer-legal" aria-label="Policies">
            {LEGAL_LINKS.map(([name, path]) => (
              <Link key={name} to={path} data-testid={`footer-${tid(name)}`}>{name}</Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  </div>
);

export default Footer;
